import { FormContainer, Input, InputPassword, PasswordInputValidator } from 'Components/utility';
import i18n from 'Utilities/i18n';

import { ContentContainer, type CreateAccountFormDefinition } from '../helpers';

type RegisterAdultAccountProps = {
  formikForm: CreateAccountFormDefinition;
  identities?: Identity[];
  onValidate: (meetsReqs: boolean) => void;
};

function RegisterAdultAccount({ formikForm, identities, onValidate }: RegisterAdultAccountProps) {
  const { values, errors, touched, handleBlur, handleChange } = formikForm;

  return (
    <ContentContainer>
      <FormContainer hasHiddenUserInput>
        <Input
          aria-label={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.label'
          )}
          placeholder={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.placeholder'
          )}
          label={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.label'
          )}
          errorMessage={errors.email}
          isInvalid={Boolean(errors.email && touched.email)}
          testID="email"
          value={values.email}
          onChangeText={handleChange('email')}
          onBlur={handleBlur('email')}
          inputMode="email"
        />
        <PasswordInputValidator
          placeholder={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.placeholder'
          )}
          label={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.label'
          )}
          errors={errors}
          touched={touched}
          onChangeText={handleChange('password')}
          handleBlur={handleBlur('password')}
          password={values.password}
          onValidate={onValidate}
          identities={identities}
          testID="password"
        />
        <InputPassword
          placeholder={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.placeholder'
          )}
          label={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.label'
          )}
          isInvalid={Boolean(errors.confirmPassword && touched.confirmPassword)}
          errorMessage={errors.confirmPassword}
          testID="confirmPassword"
          onChangeText={handleChange('confirmPassword')}
          onBlur={handleBlur('confirmPassword')}
        />
      </FormContainer>
    </ContentContainer>
  );
}

export { RegisterAdultAccount };
